<div class="card" data-note-id="{{id}}">
  <div class="card-header note-badges">
    <div class="flex-center-items">
      {{{badges.user}}}
      {{{badges.age}}}
      {{{badges.comments}}}
      {{{badges.country}}}
    </div>
    <div class="flex-no-shrink ml-auto btn-group">
      {{{badges.report}}}
      {{#if watchlist}}
        {{{badges.unwatch}}}
      {{else}}
        {{{badges.watch}}}
      {{/if}}
      {{{badges.hide}}}
    </div>
  </div>

  <div class="card-body text-break">
    {{{comments.0.html}}}
  </div>

  <div class="card-footer note-actions">
    {{> actions actions}}
  </div>
</div>
